import { createContext, useContext } from 'react';
import { CurrentProjectStatus, HightouchOrg } from '../types';

type BillingQueryContextState = {
  currentProjectStatus: CurrentProjectStatus;
  hightouchOrg?: HightouchOrg;
  isError: boolean;
  isLoading: boolean;
  remainingSyncs: number;
};

export const BillingQueryContext = createContext<BillingQueryContextState | undefined>(undefined);

export const useBillingQueryContext = () => {
  const context = useContext<BillingQueryContextState | undefined>(BillingQueryContext);
  if (context === undefined) {
    throw new Error('useBillingQueryContext must be used within a BillingQueryContextProvider');
  }
  return context;
};
